module.exports = __webpack_public_path__ + "img/mo.f866a26c.svg";